import {Pipe, PipeTransform} from '@angular/core';
import IFieldCropRotation = Data.FieldManagement.IFieldCropRotation;
import ICropRotation = Data.FieldManagement.ICropRotation;
import ICropRotationCell = Data.FieldManagement.ICropRotationCell;

/**
 * convert the Field Row to a Cell Value
 */
@Pipe({
  name: 'toCellValue'
})
export class ToCellValuePipe implements PipeTransform {

  transform(value: IFieldCropRotation | ICropRotation, args?: [number, number]): ICropRotationCell {
    const currentYear = args[1];
    const yearIdx = args[0];
    const itemIndex = yearIdx + 1;
    return Array.isArray(value.Yields) && !!value.Yields[itemIndex] ? {
      FieldId: value.Id,
      YearIndex: yearIdx,
      Year: currentYear + yearIdx,
      MainCrop: value.Yields[itemIndex].MainCrop,
      MainCropYield: value.Yields[itemIndex].MainCropYield,
      MainCropStraw: value.Yields[itemIndex].MainCropStraw,
      SecondCrop: value.Yields[itemIndex].SecondCrop,
      SecondCropYield: value.Yields[itemIndex].SecondCropYield
    } as ICropRotationCell : {
      FieldId: value.Id,
      YearIndex: yearIdx,
      Year: currentYear + yearIdx,
      MainCrop: 0,
      MainCropYield: 0,
      MainCropStraw: false,
      SecondCrop: 0,
      SecondCropYield: 0
    };
  }

}
